import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import {
  TestBuy,
  TestBuyProductWithCriteria,
} from "@coworker/types/lib/testbuy";
import { TestbuyItemsListViewItem } from "@coworker/apprestructured/src/testbuy/components/TestbuyItemsListViewItem/TestbuyItemsListViewItem";
import { useState } from "react";

interface TestbuyItemsListViewProps {
  testbuy: TestBuy;
  filteredTestbuyItems: TestBuyProductWithCriteria[];
  allTestbuyItemNos?: string[];
  isItemCompletedInTestbuy?: boolean;
  testId?: string;
  isCompletedTestbuy?: boolean;
}

export const TestbuyItemsListView = ({
  filteredTestbuyItems,
  testbuy,
  allTestbuyItemNos,
  isItemCompletedInTestbuy,
  isCompletedTestbuy,
}: TestbuyItemsListViewProps) => {
  const [replaceArticleLoading, setReplaceArticleLoading] = useState(false);
  return (
    <FixaListView id={"testbuy-items-list-view"}>
      {filteredTestbuyItems.map((testbuyItem) => (
        <TestbuyItemsListViewItem
          key={testbuyItem.id}
          testbuy={testbuy}
          testbuyItem={testbuyItem}
          setReplaceArticleLoading={setReplaceArticleLoading}
          replaceArticleLoading={replaceArticleLoading}
          allTestbuyItemNos={allTestbuyItemNos ?? []}
          isItemCompletedInTestbuy={isItemCompletedInTestbuy || false}
          isCompletedTestbuy={isCompletedTestbuy || false}
        />
      ))}
    </FixaListView>
  );
};
